import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FaLock, FaExclamationTriangle } from 'react-icons/fa';
import AnimatedModal from './AnimatedModal';
import ModalHelp from '../../../components/ModalHelp';
import BackendErrorMessage from '../../../components/BackendErrorMessage';

interface FecharBancaModalProps {
  banca: any;
  onClose: () => void;
  onConfirm: () => void;
}

const FecharBancaModal: React.FC<FecharBancaModalProps> = ({ 
  banca, 
  onClose, 
  onConfirm 
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      toast.success('Banca fechada com sucesso!');
    } catch (error) {
      console.error('Erro ao fechar banca:', error);
      toast.error(BackendErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <AnimatedModal isOpen={true} onClose={onClose}>
      <div style={{
        backgroundColor: 'white', padding: '32px', borderRadius: '12px',
        width: '480px', maxWidth: '90vw',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ 
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: '48px', height: '48px', borderRadius: '50%',
            backgroundColor: '#fef2f2', marginBottom: '12px'
          }}>
            <FaLock style={{ color: '#dc2626', fontSize: '20px' }} />
          </div>
          <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
            Fechar Banca
        <ModalHelp text="Fechar a banca encerra as votações. Após o fechamento, a ATA pode ser gerada. Use esta opção quando a banca não teve candidatos ou não foi utilizada." />
          </h3>
        </div>

        {/* Content */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{
            backgroundColor: '#fef3c7', padding: '16px', borderRadius: '8px',
            marginBottom: '16px', border: '1px solid #fbbf24',
            display: 'flex', alignItems: 'flex-start', gap: '12px'
          }}>
            <FaExclamationTriangle style={{ color: '#d97706', fontSize: '16px', marginTop: '2px' }} />
            <div style={{ fontSize: '14px', color: '#92400e' }}>
              <strong>Atenção:</strong> Esta ação fechará definitivamente a banca por desuso 
              (não houveram candidatos ou a banca não foi utilizada).
            </div>
          </div>

          <div style={{
            backgroundColor: '#f8f9fa', padding: '16px', borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <div style={{ marginBottom: '8px' }}>
              <strong>Banca:</strong> {banca.tipoBanca?.nome}
            </div>
            <div style={{ marginBottom: '8px' }}>
              <strong>Data:</strong> {banca.dataDeBanca?.data ? 
                new Date(banca.dataDeBanca.data).toLocaleDateString('pt-BR') : 'Não definida'}
            </div>
            <div>
              <strong>Status atual:</strong> {banca.status}
            </div>
          </div>

          <div style={{
            backgroundColor: '#fee2e2', padding: '16px', borderRadius: '8px',
            marginTop: '16px', border: '1px solid #fca5a5'
          }}>
            <div style={{ fontSize: '14px', color: '#991b1b' }}>
              <strong>Consequências do fechamento:</strong>
              <ul style={{ margin: '8px 0 0 16px', padding: 0 }}>
                <li>A banca será marcada como "Fechada"</li>
                <li>Não será possível reabrir ou utilizar esta banca</li>
                <li>Nenhum candidato poderá ser vinculado a esta banca</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px', border: '1px solid #d1d5db',
              backgroundColor: 'white', borderRadius: '6px',
              cursor: 'pointer', fontSize: '14px', fontWeight: '500'
            }}
            disabled={loading}
          >
            Manter Aberta
          </button>
          
          <button
            onClick={handleConfirm}
            disabled={loading}
            style={{
              padding: '10px 20px', backgroundColor: '#dc2626',
              color: 'white', border: 'none', borderRadius: '6px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '14px', fontWeight: '500',
              opacity: loading ? 0.6 : 1,
              display: 'flex', alignItems: 'center', gap: '6px'
            }}
          >
            {loading ? 'Fechando...' : (
              <>
                <FaLock style={{ fontSize: '12px' }} />
                Confirmar Fechamento
              </>
            )}
          </button>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default FecharBancaModal;